module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Ga-Hb 后背.f601b0d3.png";